﻿const menuApp = {
    data() {
        return {
            user: null,
            userTimeout: null,

            menuElement: null,
            navbarBurger: null,
            drillLinks: null,
            backLinks: null,
            dropdownLinks: null
        }
    },
    methods: {
        checkAccess(levels, allowClaimsRelevant = 'False') {
            if (this.user === null) {
                return false
            } else {
                let levelArray = levels.split(',');
                return allowClaimsRelevant === 'True' ?
                    levelArray.includes(this.user.roleName) && this.user.organisationAllowNewClaims :
                    levelArray.includes(this.user.roleName);
            }
        },
        checkUser() {
            if (this.user === null) {
                this.user = JSON.parse(sessionStorage.getItem('user'));
            } else {
                clearTimeout(this.userTimeout);
            }
        }
    },
    mounted() {
        this.menuElement = this.$el.parentNode;
        this.navbarBurger = document.getElementById('navbar-burger');

        if (this.navbarBurger) {
            this.navbarBurger.addEventListener('click', (event) => {
                this.navbarBurger.classList.toggle('is-active');
                this.menuElement.classList.toggle('is-active');
            });

            document.addEventListener('click', (event) => {
                let isClickInside = false;

                if (this.menuElement.contains(event.target) || this.navbarBurger.contains(event.target)) {
                    isClickInside = true;
                }

                if (!isClickInside) {
                    this.navbarBurger.classList.remove('is-active');
                    this.menuElement.classList.remove('is-active');
                }
            });
        }

        this.drillLinks = this.$refs.drilldownlink && this.$refs.drilldownlink.length ? this.$refs.drilldownlink : [this.$refs.drilldownlink];
        this.drillLinks = this.drillLinks.filter(link => link);
        this.backLinks = this.$refs.backlink && this.$refs.backlink.length ? this.$refs.backlink : [this.$refs.backlink];
        this.backLinks = this.backLinks.filter(link => link);
        this.dropdownLinks = this.$refs.dropdownlink && this.$refs.dropdownlink.length ? this.$refs.dropdownlink : [this.$refs.dropdownlink];
        this.dropdownLinks = this.dropdownLinks.filter(link => link);

        this.drillLinks.forEach(drillLink => {
            drillLink.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                let $targetMenu = drillLink.nextSibling;
                $targetMenu.classList.add('active');
            }, false);
        });
        
        this.backLinks.forEach(backLink => {
            backLink.addEventListener('click', (event) => {
                let $targetMenu = event.target.closest('.mainmenu-child');
                $targetMenu.classList.remove('active');
            }, false);
        });

        this.dropdownLinks.forEach(dropdownLink => {
            const parent = dropdownLink.parentNode;

            dropdownLink.addEventListener('click', (event) => {

                event.preventDefault();
                event.stopPropagation();
                parent.classList.toggle('is-active');
            });

            document.addEventListener('click', (event) => {
                let isClickInside = false;

                if (dropdownLink.contains(event.target) || parent.contains(event.target)) {
                    isClickInside = true;
                }

                if (!isClickInside) {
                    parent.classList.remove('is-active');
                }
            });
        })
        

        this.userTimeout = setTimeout(() => this.checkUser(), 500);
    }
}

export default menuApp;